import React, { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import styled from 'styled-components'
import {
  ArrowLeft,
  Download,
  Grid3x3,
  Heart,
  ImagePlus,
  Trash2,
} from 'lucide-react'
import { useAppDispatch, useAppSelector } from '../../../../Redux/Hooks'
import { useNavigate } from 'react-router-dom'
import { showErrorToast } from '../../../atoms/Utlis/Toast'
import { Folder, LikedImageType } from '../../../../Data/album.dto'

import LoadingDots from '../../../atoms/Utlis/LoadinDots'
import SelectedIconPNG from '../../../../assets/Icons/tick.png'
import DeletePopup from '../../../atoms/Dashboard/Folder/DeletePopup'
import {
  deleteAllFolderImagesAPI,
  deleteFolderImagesAPI,
  getFolderLikedImageAPIV2,
  getSingleFolderAPI,
  updateFolderAPI,
  updateFolderNameAPI,
} from '../../../../Redux/ApiCalls/Dashboard/FolderApi'
import DiscardPopUp from '../../../atoms/Dashboard/Folder/DiscardSelectedImagesPopup'
import {
  addToCompressingFolder,
  removeFromCompressingFolder,
} from '../../../../Redux/Slice/Dashboard/AlbumSlice'
import ImageWithSkeleton from '../../../atoms/Dashboard/Folder/ImageWraper'
import RedLikeIcon from '../../../../assets/Icons/LikedIcon.svg'
import { RedeemUsers } from '../../../../Data/user.dto'
import SelectRedeemUserListPopup from '../../../atoms/Dashboard/Folder/SelectRedeemUserListPopup'
import ImageWithBlob from '../../../atoms/Dashboard/Folder/UploadedImage'
import Errortext from '../../../atoms/Utlis/Errortext'
import { Modal } from 'antd'
import UploadImageModalComponent from '../../../atoms/Dashboard/Folder/UploadImageModal'
import CompressionModal from '../../../atoms/Dashboard/Folder/CompressionRate'
import FullPageImageCarousel, { CarouselImageItem } from '../../../atoms/Dashboard/Folder/FullPageImageCarousel'
import MarketplaceEmptyState from '../../../organisms/Dashboard/Marketplace/MarketplaceEmptyState'
import { IMAGE_CDN } from '../../../../config/config'
import * as XLSX from 'xlsx'
import PermissionGate from '../../../atoms/Utlis/PermissionGate'
import { usePermissions } from '../../../../hooks/usePermissions'
import JSZip from 'jszip'
import {
  PageContainer as BasePageContainer,
  ScrollBody as BaseScrollBody,
  FormCard,
  CardIcon,
  CardTitle,
  CardSubtitle,
  Field,
  Label,
  Input,
  RequiredStar,
  SubmitBar,
  SubmitHint,
  SubmitButton,
  DeleteBtn,
  gradient,
} from './albumFormSharedStyles'
import {
  BackButton,
} from '../Member/memberFormStyles'
import { device } from '../../../atoms/Utlis/media'

const PageContainer = styled(BasePageContainer)`
  width: 100%;
  height: 100%;
  max-height: calc(100dvh - 90px);
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
`

const ScrollBody = styled(BaseScrollBody)`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-right: 4px;
`

const FolderHeaderCard = styled(FormCard)`
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 10;
`

const FolderSubmitBar = styled(SubmitBar)`
  position: sticky;
  bottom: 0;
  z-index: 10;
  background: #fff;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.06);
`

const CardHeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`

const CardHeaderInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 1;
`

const Toolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`

const ToolbarLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`

const ViewPills = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`

const ViewPill = styled.button<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 12px;
  border-radius: 999px;
  border: 1px solid ${(p) => (p.$active ? 'rgba(201, 77, 170, 0.3)' : 'rgba(23, 23, 23, 0.08)')};
  background: ${(p) => (p.$active ? 'rgba(201, 77, 170, 0.1)' : '#fff')};
  color: ${(p) => (p.$active ? '#c94daa' : 'rgba(23, 23, 23, 0.65)')};
  font-family: Urbanist, sans-serif;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s ease;
`

const CheckOption = styled.label<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: ${(p) => (p.$active ? '#171717' : 'rgba(23, 23, 23, 0.5)')};
`

const StyledCheckbox = styled.input`
  width: 18px;
  height: 18px;
  accent-color: #c94daa;
  cursor: pointer;
`

const ExportButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 12px;
  border: none;
  border-radius: 999px;
  background: ${gradient};
  color: #fff;
  font-family: Urbanist, sans-serif;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(201, 77, 170, 0.22);
  transition: transform 0.15s ease;
  &:hover { transform: translateY(-1px); }
`

const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 16px;
  align-items: start;
  padding: 4px 0;

  @media ${device.mobileL} {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  }
`

const ImageUploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  align-items: center;
  width: 100%;
  aspect-ratio: 1 / 1;
  border: 2px dashed rgba(201, 77, 170, 0.28);
  border-radius: 16px;
  background: linear-gradient(
    180deg,
    rgba(201, 77, 170, 0.04) 0%,
    rgba(255, 201, 81, 0.04) 100%
  );
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s, transform 0.15s;
  box-sizing: border-box;
  &:hover {
    border-color: rgba(201, 77, 170, 0.45);
    background: rgba(201, 77, 170, 0.06);
    transform: translateY(-1px);
  }
  &:active { transform: scale(0.98); }
`

const AddImageLabel = styled.p`
  margin: 0;
  color: #c94daa;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
`

const UploadIconWrap = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(201, 77, 170, 0.1);
  color: #c94daa;
`
const ImagePreview = styled.div`
  position: relative;
  width: 100%;
  cursor: pointer;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(23, 23, 23, 0.06);
  background: #fff;
  display: flex;
  flex-direction: column;
  isolation: isolate;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12);
  }
`

const LoadMoreSentinel = styled.div`
  grid-column: 1 / -1;
  height: 1px;
  width: 100%;
  pointer-events: none;
`

const ImageName = styled.div`
  width: 100%;
  color: rgba(23, 23, 23, 0.72);
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 600;
  padding: 8px 10px 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const SelectedIconContainer = styled.div`
  position: absolute;
  top: 8px;
  right: 10px;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;

  box-shadow: 0px 4px 14px 0px #00000080;

  height: 19px;
  width: 19px;
`

const LikedImageContainer = styled.div`
  position: absolute;
  top: 8px;
  left: 10px;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #00000099;
  height: 26px;
  width: 30px;
`
const SelectedIcon = styled.img`
  height: 19px;
  width: 19px;
`

const LoadingWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 0;
`

const EmptyStateWrap = styled.div`
  grid-column: 1 / -1;
`

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  flex-shrink: 0;
`

const DownloadActionBtn = styled(SubmitButton)`
  min-width: unset;
  height: 44px;
  padding: 0 20px;
  font-size: 14px;
`

const DeleteActionBtn = styled(DeleteBtn)`
  height: 44px;
  padding: 0 18px;
  font-size: 13px;
`

const CancelSelectBtn = styled.button`
  height: 44px;
  padding: 0 14px;
  border-radius: 10px;
  border: 1px solid rgba(23, 23, 23, 0.1);
  background: #fff;
  font-family: Urbanist, sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: rgba(23, 23, 23, 0.65);
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover {
    border-color: rgba(201, 77, 170, 0.25);
    color: #c94daa;
  }
`

let urls: string[] = []
const UpdateFolderPage = () => {
  const dispatch = useAppDispatch()
  const {
    currentFolder,
    isError,
    isFolderChange,
    redeemUsers,
    folderLoading,
    error,
    updatedFolderList,
    uploadFolderProgress,
    currentCompressingFolder,
    currentAlbum,
  } = useAppSelector((state) => state.album)
  const { likeImages: folderLikedImages } = useAppSelector(state => state.folder)
  const { hasPermission } = usePermissions()
  const canDownloadMedia = hasPermission('albums.download_media')
  const canDeleteMedia = hasPermission('albums.edit_delete_media')
  const canUploadMedia = hasPermission('albums.upload_media')
  const canUpdateFolder = hasPermission('albums.update')
  const canSelectImages = canDownloadMedia || canDeleteMedia
  const { watermark } = useAppSelector((state) => state.auth)
  const [folder, setFolder] = useState<Folder>()
  const isWatermarkActive = !!((currentFolder?.activate_watermark || currentAlbum?.activate_watermark) && watermark)
  const watermarkUrl = watermark ? `${IMAGE_CDN}/${watermark}` : undefined
  const fileInputRef = useRef<HTMLInputElement>(null)
  const [newFolderImages, setNewFolderImages] = useState<File[]>([])
  const [folderName, setFolderName] = useState<string>('')
  const [selectedFolderImages, setSelectedFolderImages] = useState<number[]>([])

  const [isSelectAll, setIsSelectAll] = useState(false)
  const [folderImages, setFolderImages] = useState<
    {
      id: number
      thumbnail: string
      project_id: number
      image: string
      media_type: number
    }[]
  >()
  const [compresedImageLoading, setCompresedImageLoading] = useState(false)
  const [activeUploadButton, setActiveUploadButton] = useState(true)
  const [deletModal, setDeleteModal] = useState(false)
  const [downloadingImages, setDownloadingImages] = useState(false)
  const [isImageSelected, setIsImageSelected] = useState(false)
  const [previewImageUrl, setPreviewImageUrl] = useState<string[]>([])
  const [compressionRateModal, setCompressionRateModal] = useState(false)
  const [likedImages, setLikedImages] = useState<
    LikedImageType[]
  >([])
  const [selectedLikedUserId, setSelectedLikedUserId] = useState<number | null>(null)
  const [uploadImageModal, setUploadImageModal] = useState<boolean>(false)
  const [isUpdate, setIsUpdate] = useState(false)
  const [discardPopup, setDiscardPopup] = useState(false)
  const [redeemUserPopup, setRedeemUserPopup] = useState(false)
  const [currentRedeemUsers, setCurrentRedeemUsers] = useState<RedeemUsers[]>(
    []
  )
  const observer = useRef<IntersectionObserver | null>(null)
  const [currentPage, setCurrentPage] = useState(1)
  const [showError, setShowError] = useState(false)
  const [isSeeAllImages, setIsSeeAllImages] = useState(true)
  const [compressRate, setCompressRate] = useState(25)
  const [displayedImages, setDisplayImages] = useState<
    {
      thumbnail: string
      id: number
      project_id: number
      image: string
      media_type: number
    }[]
  >([])
  const [lightboxOpen, setLightboxOpen] = useState(false)
  const [lightboxImages, setLightboxImages] = useState<CarouselImageItem[]>([])
  const [lightboxInitialIndex, setLightboxInitialIndex] = useState(0)
  const lightboxBlobUrlsRef = useRef<string[]>([])
  const navigate = useNavigate()

  // NEW: whether the currently active view (all images vs liked images) has any images to show.
  // Used to hide the "Select Images" checkbox when the folder/liked view is empty.
  const hasVisibleImages = isSeeAllImages
    ? Boolean(folderImages && folderImages.length > 0)
    : Boolean(likedImages && likedImages.length > 0)

  const openLightbox = (initialIndex: number) => {
    const newBlobUrls = newFolderImages.map((f) => URL.createObjectURL(f))
    lightboxBlobUrlsRef.current = newBlobUrls
    const newItems: CarouselImageItem[] = newBlobUrls.map((url) => ({ url }))
    const sourceImages = isSeeAllImages ? folderImages : likedImages
    const existingItems: CarouselImageItem[] = (sourceImages ?? []).map(
      (img) => ({
        url: `${IMAGE_CDN}/${img.image}`,
        thumbnail: `${IMAGE_CDN}/${img.thumbnail}`,
      })
    )
    setLightboxImages([...newItems, ...existingItems])
    setLightboxInitialIndex(initialIndex)
    setLightboxOpen(true)
  }

  const closeLightbox = () => {
    lightboxBlobUrlsRef.current.forEach((url) => URL.revokeObjectURL(url))
    lightboxBlobUrlsRef.current = []
    setLightboxOpen(false)
  }
  useEffect(() => {
    if (!currentFolder) {
      navigate(-1)
    } else {
      setFolder(currentFolder)
      setNewFolderImages([])
      setFolderName(currentFolder.name)
      setFolderImages(currentFolder.images)
      setDisplayImages(currentFolder.images.slice(0, 55))
      setSelectedFolderImages([])
    }
  }, [])
  useEffect(() => {
    // Set the 'webkitdirectory' attribute after the component is rendered
    if (fileInputRef.current) {
      fileInputRef.current.setAttribute('webkitdirectory', 'true')
    }
  }, [])

  useEffect(() => {
    if (folderLikedImages.data && folderLikedImages.data.length) {
      setLikedImages(folderLikedImages.data ?? [])
    } else {
      setLikedImages([])
    }

  }, [folderLikedImages.data])

  useEffect(() => {
    // const worker = new MyWorker('')
    if (redeemUsers && redeemUsers.length > 0) {
      setCurrentRedeemUsers(redeemUsers)
    } else {
      setCurrentRedeemUsers([])
    }
    return () => {
      // setPreviewImageUrl([])
    }
  }, [redeemUsers])

  useEffect(() => {
    isUploadActiveButton()
  }, [newFolderImages, folderName])

  useEffect(() => {
    // // console.log("calling ++++")
    if (currentFolder) {
      if (
        updatedFolderList.find(
          (folder) => folder.folder_id === currentFolder.id
        )
      ) {
        setSelectedFolderImages([])
        setIsUpdate(false)
        setIsImageSelected(false)
        setNewFolderImages([])
        dispatch(
          getSingleFolderAPI({
            folder_id: currentFolder?.id,
            page: 1,
            page_size: 50,
          })
        )
        if (!isSeeAllImages && selectedLikedUserId !== null) {
          dispatch(
            getFolderLikedImageAPIV2({
              user_id: selectedLikedUserId,
              folder_id: currentFolder.id,
            })
          )
        }
      }
    }
  }, [updatedFolderList, isSeeAllImages, selectedLikedUserId, currentFolder])
  useEffect(() => {
    if (currentFolder) {
      if (
        currentCompressingFolder.find(
          (folder) => folder.folderId === currentFolder.id
        )
      ) {
        setCompresedImageLoading(true)
      }
    }
  }, [currentCompressingFolder])
  useEffect(() => {
    if (
      uploadFolderProgress &&
      uploadFolderProgress.length > 0 &&
      currentFolder &&
      uploadFolderProgress.find((f) => f.folderId === currentFolder.id)
    ) {
      setNewFolderImages([])
      setPreviewImageUrl([])
      navigate(-1)
    }

    return () => {
      urls.forEach((link) => URL.revokeObjectURL(link))
    }
  }, [uploadFolderProgress])
  useEffect(() => {
    if (!observer.current && newFolderImages.length > 0) {
      observer.current = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const imageId = parseInt(entry.target.getAttribute('data-id')!)
            console.log(imageId, previewImageUrl[imageId])
            if (
              entry.isIntersecting &&
              previewImageUrl[imageId] === undefined
            ) {
              // const file = images.find((img) => img.id === parseInt(imageId))?.file;
              // console.log("calling inside if condition ")
              setPreviewImageUrl((pre) => {
                pre[imageId] = URL.createObjectURL(newFolderImages[imageId])
                return pre
              })
            }
          })
        },
        {
          threshold: 0.1,
        }
      )
    }
  }, [newFolderImages])
  useEffect(() => {
    if (currentFolder && currentFolder.images) {
      setFolderImages(currentFolder.images)
    }
  }, [currentFolder?.images])

  // useEffect(()=>{
  //   let timeout:any;
  //   if(compresedImageLoading){
  //     timeout=setTimeout(()=>{
  //       showWarningToast("Compression in progress — don't leave this screen!")
  //     },1000)
  //   }else{
  //     if(timeout){
  //       clearTimeout(timeout)
  //     }
  //   }
  //   return()=>{
  //     clearTimeout(timeout)
  //   }
  // },[compresedImageLoading])

  /** Extract display name from image path*/
  function getImageNameFromPath(imagePath: string): string {
    if (!imagePath) return ''
    const filename = imagePath.split('/').pop() || ''
    const withoutExt = filename.replace(/\.[^.]+$/, '')
    const underscoreIndex = withoutExt.indexOf('_')
    return underscoreIndex >= 0 ? withoutExt.slice(underscoreIndex + 1) : withoutExt
  }

  const MAX_IMAGES_PER_UPLOAD = 2000

  const handleImageUpload = async (files: File[]) => {
    if (!files?.length || !currentFolder) return
    if (files.length > MAX_IMAGES_PER_UPLOAD) {
      showErrorToast(
        `You can upload up to ${MAX_IMAGES_PER_UPLOAD} images at a time.`,
      )
      setUploadImageModal(false)
      return
    }

    setCompresedImageLoading(true)
    setUploadImageModal(false)
    previewImageUrl.forEach((url) => {
      if (url) URL.revokeObjectURL(url)
    })
    setPreviewImageUrl([])

    if (Number(compressRate) > 0) {
      dispatch(
        addToCompressingFolder({
          folderId: currentFolder.id,
          folderName: currentFolder.name,
          totalProgress: 0.01,
        }),
      )
    }

    try {
      await dispatch(
        updateFolderAPI({
          project_id: currentFolder.project_id,
          id: currentFolder.id,
          folder_name: folderName,
          folderImages: Array.from(files),
          compression_percentage: compressRate,
        }),
      ).unwrap()
    } catch {
      // updateFolderAPI.rejected shows toast via reducer
    } finally {
      setCompresedImageLoading(false)
      dispatch(removeFromCompressingFolder(currentFolder.id))
    }
  }

  const handleRemoveImage = (index: number) => {
    setNewFolderImages((prev) => {
      const updatedImages = [...prev]
      updatedImages.splice(index, 1) // Remove the image at the given index
      return updatedImages
    })
  }

  const handleSelectedImage = (id: number, url: string) => {
    if (isSelectAll) setIsSelectAll(false)
    setSelectedFolderImages((prev) =>
      prev.includes(id)
        ? prev.filter((imageId) => imageId !== id)
        : [...prev, id]
    )
  }
  const isUploadActiveButton = () => {
    if (folderName !== folder?.name || newFolderImages.length !== 0) {
      setActiveUploadButton(false)
    } else {
      setActiveUploadButton(true)
    }
  }
  const handleUpdateFolder = () => {
    if (folder && isValidName(folderName)) {
      if (newFolderImages.length > 0)
        dispatch(
          updateFolderAPI({
            project_id: folder.project_id,
            id: folder?.id,
            folder_name: folderName,
            folderImages: newFolderImages,
            compression_percentage: compressRate,
          })
        )
      else {
        dispatch(
          updateFolderNameAPI({
            project_id: folder.project_id,
            id: folder?.id,
            folder_name: folderName,
          })
        )
      }
    } else {
      setShowError(true)
    }
    // formData.append('folder_id', `${folder?.id}`);
    // if (folderName)
    //   formData.append('folder_name', folderName);
    // else
    //   formData.append('folder_name', `${folder?.name}`);
    // newFolderImages.forEach((image, index) => {
    //   formData.append(`media[${index}][image]`, image);
    //   formData.append(`media[${index}][media_type]`, "1");
    // })
  }
  const deleteFolderImages = () => {
    if (currentFolder) {
      if (isSelectAll) {
        dispatch(
          deleteAllFolderImagesAPI({
            folder_id: currentFolder.id,
            project_id: currentFolder.project_id,
          })
        )
      } else {

        dispatch(
          deleteFolderImagesAPI({
            media_ids: selectedFolderImages,
            folder_id: currentFolder.id,
            project_id: currentFolder.project_id,
          })
        )
      }
    }

    setDeleteModal(false)
  }
  const SelectCheckbox = () => {
    // // console.log(isImageSelected)
    if (!isImageSelected) {
      enterSelectionMode()
    } else {
      setIsImageSelected(false)
      setSelectedFolderImages([])
      setIsSelectAll(false)
      // // console.log(selectedFolderImages)
    }
  }

  const enterSelectionMode = () => {
    if (isImageSelected) return
    setIsSelectAll(false)
    if (newFolderImages.length > 0 || currentFolder?.name !== folderName) {
      setDiscardPopup(true)
    } else {
      setIsUpdate(false)
      setIsImageSelected(true)
    }
  }

  const handleHeaderDownload = () => {
    if (!isImageSelected) {
      enterSelectionMode()
      return
    }
    if (selectedFolderImages.length === 0 || downloadingImages) return
    handleDownloadImages()
  }

  const handleHeaderDelete = () => {
    if (!isImageSelected) {
      enterSelectionMode()
      return
    }
    if (selectedFolderImages.length === 0) return
    setDeleteModal(true)
  }
  const getCORSFetchUrl = (url: string) => {
    return url.includes("?") ? `${url}&cors=1` : `${url}?cors=1`;
  };

  const downloadSingleImage = async (url: string, filename: string) => {
    try {
      const fetchUrl = getCORSFetchUrl(url);
      const response = await fetch(fetchUrl, { mode: "cors" });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Failed to download image", error);
      showErrorToast("Failed to download image");
    }
  };

  const downloadMultipleImagesAsZip = async (imagesToDownload: { url: string; filename: string }[]) => {
    try {
      const zip = new JSZip();
      const fileCounts: { [key: string]: number } = {};

      const fetchPromises = imagesToDownload.map(async (img) => {
        try {
          const fetchUrl = getCORSFetchUrl(img.url);
          const response = await fetch(fetchUrl, { mode: "cors" });
          if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
          const blob = await response.blob();

          let name = img.filename;
          if (fileCounts[name] !== undefined) {
            fileCounts[name]++;
            const dotIdx = name.lastIndexOf(".");
            if (dotIdx !== -1) {
              name = `${name.substring(0, dotIdx)} (${fileCounts[name]})${name.substring(dotIdx)}`;
            } else {
              name = `${name} (${fileCounts[name]})`;
            }
          } else {
            fileCounts[name] = 0;
          }
          zip.file(name, blob);
        } catch (e) {
          console.error(`Failed to fetch image: ${img.url}`, e);
        }
      });

      await Promise.all(fetchPromises);

      const content = await zip.generateAsync({ type: "blob" });
      const blobUrl = URL.createObjectURL(content);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `${folderName || currentFolder?.name || "folder"}-images.zip`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Failed to create ZIP file", error);
      showErrorToast("Failed to create ZIP file");
    }
  };

  const handleDownloadImages = async () => {
    if (selectedFolderImages.length === 0) return;

    setDownloadingImages(true);
    try {
      const sourceImages: any[] = isSeeAllImages ? (folderImages || []) : (likedImages || []);
      const selectedImages = sourceImages.filter((img: any) =>
        selectedFolderImages.includes(img.id)
      );

      if (selectedImages.length === 1) {
        const img = selectedImages[0];
        const url = `${IMAGE_CDN}/${img.image}`;
        const ext = img.image.split(".").pop() || "jpg";
        let filename = (img as any).original_file_name || getImageNameFromPath(img.image);
        if (!filename.toLowerCase().endsWith(`.${ext.toLowerCase()}`)) {
          filename = `${filename}.${ext}`;
        }
        await downloadSingleImage(url, filename);
      } else {
        const imagesToDownload = selectedImages.map((img: any) => {
          const url = `${IMAGE_CDN}/${img.image}`;
          const ext = img.image.split(".").pop() || "jpg";
          let filename = (img as any).original_file_name || getImageNameFromPath(img.image);
          if (!filename.toLowerCase().endsWith(`.${ext.toLowerCase()}`)) {
            filename = `${filename}.${ext}`;
          }
          return { url, filename };
        });
        await downloadMultipleImagesAsZip(imagesToDownload);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setDownloadingImages(false);
    }
  };

  const handleSelectAllToggle = () => {
    if (!isImageSelected) return
    setIsSelectAll((prev) => {
      const next = !prev
      if (next) {
        const sourceImages = isSeeAllImages ? folderImages : likedImages
        if (sourceImages && sourceImages.length > 0) {
          const allIds = Array.from(new Set(sourceImages.map((img) => img.id)))
          setSelectedFolderImages(allIds)
        } else {
          setSelectedFolderImages([])
        }
      } else {
        setSelectedFolderImages([])
      }
      return next
    })
  }
  const ImageUploadCheck = () => {
    if (isImageSelected) {
      if (selectedFolderImages.length > 0) {
        setDiscardPopup(true)
      } else {
        setIsImageSelected(false)
        if (fileInputRef.current) fileInputRef.current.value = ''
        setCompressionRateModal(true)
        setIsUpdate(true)
      }
    } else {
      if (fileInputRef.current) fileInputRef.current.value = ''
      setCompressionRateModal(true)
      setIsUpdate(true)
    }
  }
  const DiscardAllChanges = () => {
    setIsUpdate(false)
    if (currentFolder) setFolderName(currentFolder.name)
    setSelectedFolderImages([])
    setNewFolderImages([])
    setIsImageSelected(false)
    setIsSelectAll(false)
    setDiscardPopup(false)
  }
  const folderNameChange = (name: string) => {
    if (name.length <= 30) {
      if (name !== currentFolder?.name) {
        if (isImageSelected) {
          if (selectedFolderImages.length > 0) {
            setDiscardPopup(true)
          } else {
            setIsImageSelected(false)
            setFolderName(name)
            setIsUpdate(true)
          }
        } else {
          // fileInputRef?.current?.click()
          setIsUpdate(true)
          setFolderName(name)
        }
      } else {
        setIsUpdate(false)
        setFolderName(currentFolder?.name)
        // setFolderName(name);
      }
    }
  }

  const isLoadingMoreRef = useRef(false)
  const loadErrorRef = useRef(false)

  // Reset pagination state when folder changes
  useEffect(() => {
    loadErrorRef.current = false
    isLoadingMoreRef.current = false
    setCurrentPage(1)
  }, [currentFolder?.id])

  const loadMoreImages = async () => {
    if (!currentFolder || !folderImages) return
    const currentLength = folderImages.length
    if (
      currentLength >= currentFolder.total_images ||
      folderLoading ||
      isLoadingMoreRef.current ||
      loadErrorRef.current
    ) {
      return
    }

    const nextPage = currentPage + 1
    isLoadingMoreRef.current = true

    try {
      const res = await dispatch(
        getSingleFolderAPI({
          folder_id: currentFolder.id,
          page: nextPage,
          page_size: 50,
        })
      ).unwrap()

      setCurrentPage(nextPage)
      if (!res?.folder?.images || res.folder.images.length === 0) {
        loadErrorRef.current = true
      }
    } catch (err) {
      loadErrorRef.current = true
    } finally {
      isLoadingMoreRef.current = false
    }
  }

  const loadMoreRef = useRef<HTMLDivElement>(null)
  const scrollBodyRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const node = loadMoreRef.current
    if (!node || loadErrorRef.current) return
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) loadMoreImages()
      },
      { root: scrollBodyRef.current || null, rootMargin: '240px', threshold: 0 }
    )
    observer.observe(node)
    return () => observer.disconnect()
    // Intentionally depend on pagination inputs so observer rebinds when list grows
  }, [currentFolder?.id, currentFolder?.total_images, folderImages?.length, folderLoading, currentPage])

  const handleExportLikedImages = () => {
    if (!likedImages.length) return;

    const header = "file_name\n";

    const rows = likedImages
      .map((image) => {
        const fileName = image.original_file_name;
        const url = `${IMAGE_CDN}/${image.image}`;
        return `"${fileName.replace(/"/g, '""')}"`; // CSV-safe quoting
      })
      .join("\n");

    const csvContent = `${header}${rows}`;

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `${folderName || currentFolder?.name || "liked-images"}-liked-images.csv`
    );

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  // =======================
  // EXPORT REAL EXCEL (.xlsx)
  // =======================
  const handleExportLikedImagesExcel = () => {
    if (!likedImages.length) return;

    // Build JSON array for Excel
    const data = likedImages.map((image) => {
      const fileName = image.original_file_name;
      const url = `${IMAGE_CDN}/${image.image}`;
      return { "File Name": fileName, "Url": url };
    });

    // Create worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Create workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Liked Images");

    // Download file
    XLSX.writeFile(
      workbook,
      `${currentAlbum?.name}-${folderName || currentFolder?.name || "liked-images"}-liked-images.xlsx`
    );
  };

  useEffect(() => {
    if (isSelectAll && isImageSelected) {
      const sourceImages = isSeeAllImages ? folderImages : likedImages
      if (sourceImages && sourceImages.length > 0) {
        const allIds = Array.from(new Set(sourceImages.map((img) => img.id)))
        setSelectedFolderImages(allIds)
      } else {
        setSelectedFolderImages([])
      }
    }
  }, [folderImages, likedImages, isSeeAllImages, isSelectAll, isImageSelected])

  const getLikedImagesForRedeemUsers = (id: number) => {
    if (currentFolder && currentAlbum) {
      dispatch(
        getFolderLikedImageAPIV2({
          user_id: id,
          folder_id: currentFolder.id
        })
      )
      setSelectedLikedUserId(id)
      setRedeemUserPopup(false)
      setIsSeeAllImages(false)
    }
  }

  const isValidName = (name: string) => {
    if (name.trim().length > 0 && name.trim().length < 40) return true
    else return false
  }

  const canSave = !activeUploadButton && !compresedImageLoading

  return (
    <PageContainer>
      {createPortal(
        <>
          {deletModal && (
            <DeletePopup
              buttonText="Delete"
              cancel={() => setDeleteModal(false)}
              Delete={() => deleteFolderImages()}
              text={`Are you sure you want to remove ${isSelectAll ? 'all images' : 'selected images'} from folder?`}
            />
          )}
          {redeemUserPopup && (
            <SelectRedeemUserListPopup
              showFunction={(id: number) => getLikedImagesForRedeemUsers(id)}
              redeemUser={currentRedeemUsers}
              closeModal={() => setRedeemUserPopup(false)}
            />
          )}
          {discardPopup && (
            <DiscardPopUp
              cancel={() => setDiscardPopup(false)}
              Delete={() => DiscardAllChanges()}
            />
          )}
          {compressionRateModal && (
            <CompressionModal
              initialValue={compressRate}
              isOpen={compressionRateModal}
              onClose={() => setCompressionRateModal(false)}
              onSave={(value) => {
                setUploadImageModal(true)
                setCompressRate(value)
                setCompressionRateModal(false)
              }}
            />
          )}
        </>,
        document.body
      )}

      {lightboxOpen && lightboxImages.length > 0 && (
        <FullPageImageCarousel
          images={lightboxImages}
          initialIndex={lightboxInitialIndex}
          onClose={closeLightbox}
          activateWatermark={isWatermarkActive}
          watermarkUrl={watermarkUrl}
        />
      )}

      {/* <Hero>
        <HeroGlow />
        <HeroRow>
          <HeroLeft>
            <BackButton type="button" onClick={() => navigate(-1)} aria-label="Go back">
              <ArrowLeft size={18} />
            </BackButton>
            <HeroText>
              <HeroBadge>
                <Sparkles size={12} />
                Folder editor
              </HeroBadge>
              <PageTitle className="linear-text">{folderName || 'Update Folder'}</PageTitle>
              <PageSubtitle>
                Upload, organize, and manage photos in this folder.
              </PageSubtitle>
              <HeroStatPill>{totalImages} photos in folder</HeroStatPill>
            </HeroText>
          </HeroLeft>
        </HeroRow>
      </Hero> */}

      <FolderHeaderCard
        onWheel={(e) => {
          scrollBodyRef.current?.scrollBy({ top: e.deltaY })
        }}
      >
        <CardHeaderRow>
          <CardHeaderInfo>
            <BackButton type="button" onClick={() => navigate(-1)} aria-label="Go back">
              <ArrowLeft size={18} />
            </BackButton>
            <CardIcon $tone="#c94daa">
              <ImagePlus size={18} />
            </CardIcon>
            <div>
              <CardTitle>Folder details</CardTitle>
              <CardSubtitle>Rename this folder for your album organization.</CardSubtitle>
            </div>
          </CardHeaderInfo>
        </CardHeaderRow>
        <Field>
          <Label>
            Folder name <RequiredStar>*</RequiredStar>
          </Label>
          <Input
            type="text"
            value={folderName}
            onChange={(e) => folderNameChange(e.target.value)}
            placeholder="e.g. Engagement photos"
          />
          <Errortext
            show={showError && !isValidName(folderName)}
            message="Please enter valid folder name."
          />
        </Field>
      </FolderHeaderCard>

      <ScrollBody ref={scrollBodyRef}>
        <FormCard>
          <CardHeaderRow>
            <CardHeaderInfo>
              <CardIcon $tone="#35b7c8">
                <Grid3x3 size={18} />
              </CardIcon>
              <div>
                <CardTitle>Photos</CardTitle>
                <CardSubtitle>
                  {isSeeAllImages
                    ? 'All images in this folder.'
                    : 'Liked images from a redeem user.'}
                </CardSubtitle>
              </div>
            </CardHeaderInfo>
            {hasVisibleImages && (
              <HeaderActions>
                {canDownloadMedia && (
                  <DownloadActionBtn
                    type="button"
                    $ready={
                      !isImageSelected ||
                      (selectedFolderImages.length > 0 && !downloadingImages)
                    }
                    disabled={
                      isImageSelected &&
                      (selectedFolderImages.length === 0 || downloadingImages)
                    }
                    onClick={handleHeaderDownload}
                  >
                    <Download size={14} />
                    {downloadingImages ? 'Downloading...' : 'Download'}
                  </DownloadActionBtn>
                )}
                {canDeleteMedia && (
                  <DeleteActionBtn
                    type="button"
                    disabled={isImageSelected && selectedFolderImages.length === 0}
                    onClick={handleHeaderDelete}
                  >
                    <Trash2 size={14} />
                    Delete
                  </DeleteActionBtn>
                )}
                {isImageSelected && (
                  <CancelSelectBtn type="button" onClick={() => SelectCheckbox()}>
                    Cancel
                  </CancelSelectBtn>
                )}
              </HeaderActions>
            )}
          </CardHeaderRow>

          {!isSelectAll && folderLikedImages.isLoading ? (
            <LoadingWrap>
              <LoadingDots />
            </LoadingWrap>
          ) : (
            <>
              <Toolbar>
                <ToolbarLeft>
                  <ViewPills>
                    <ViewPill
                      type="button"
                      $active={isSeeAllImages}
                      onClick={() => {
                        setIsSeeAllImages(true)
                        setSelectedLikedUserId(null)
                      }}
                    >
                      <Grid3x3 size={13} />
                      All images
                    </ViewPill>
                    <ViewPill
                      type="button"
                      $active={!isSeeAllImages}
                      onClick={() => setRedeemUserPopup(true)}
                    >
                      <Heart size={13} />
                      Liked images
                    </ViewPill>
                  </ViewPills>

                  {canSelectImages && hasVisibleImages && (
                    <CheckOption $active={isImageSelected} htmlFor="selecheck">
                      <StyledCheckbox
                        type="checkbox"
                        id="selecheck"
                        onChange={() => SelectCheckbox()}
                        checked={isImageSelected}
                      />
                      Select images
                    </CheckOption>
                  )}
                  {canSelectImages && isImageSelected && (
                    <CheckOption $active={isSelectAll} htmlFor="selectall">
                      <StyledCheckbox
                        type="checkbox"
                        id="selectall"
                        onChange={handleSelectAllToggle}
                        checked={isSelectAll}
                      />
                      Select all
                    </CheckOption>
                  )}
                </ToolbarLeft>

                {!isSeeAllImages && likedImages.length > 0 && (
                  <ExportButton type="button" onClick={handleExportLikedImagesExcel}>
                    Export Excel
                  </ExportButton>
                )}
              </Toolbar>

              <ImageGrid>
                {canUploadMedia && isSeeAllImages && (
                  <ImageUploadContainer
                    onClick={() => {
                      if (!compresedImageLoading) ImageUploadCheck()
                    }}
                  >
                    {compresedImageLoading ? (
                      <LoadingDots />
                    ) : (
                      <>
                        <UploadIconWrap>
                          <ImagePlus size={22} />
                        </UploadIconWrap>
                        <AddImageLabel>Add images</AddImageLabel>
                      </>
                    )}
                    <input
                      id="image-upload"
                      type="file"
                      accept=".jpg, .jpeg, .png"
                      multiple
                      ref={fileInputRef}
                      style={{ display: 'none' }}
                    />
                  </ImageUploadContainer>
                )}

                {!compresedImageLoading &&
                  newFolderImages.map((file, index) => (
                    <ImagePreview key={`new-${index}`}>
                      <ImageWithBlob
                        imageFile={file}
                        index={index}
                        handleRemoveFile={handleRemoveImage}
                        onViewFullScreen={() => openLightbox(index)}
                        activateWatermark={isWatermarkActive}
                        watermarkUrl={watermarkUrl}
                      />
                      <ImageName>{file.name.replace(/\.[^.]+$/, '')}</ImageName>
                    </ImagePreview>
                  ))}

                {!isSeeAllImages && likedImages.length === 0 && !folderLikedImages.isLoading && (
                  <EmptyStateWrap>
                    <MarketplaceEmptyState
                      icon={<Heart size={28} />}
                      title="No liked images yet"
                      description="This customer hasn't liked any photos in this folder. Try another redeem user or switch back to all images."
                      actions={[
                        {
                          label: 'View all images',
                          icon: <Grid3x3 size={14} />,
                          onClick: () => {
                            setIsSeeAllImages(true)
                            setSelectedLikedUserId(null)
                          },
                        },
                        {
                          label: 'Choose another user',
                          icon: <Heart size={14} />,
                          variant: 'secondary',
                          onClick: () => setRedeemUserPopup(true),
                        },
                      ]}
                      hint={{
                        text: 'Liked photos appear when customers tap the heart on images in the app',
                      }}
                      padding="16px 0 8px"
                    />
                  </EmptyStateWrap>
                )}

                {folderImages &&
                  folderImages.length !== 0 &&
                  displayedImages.length !== 0 &&
                  (isSeeAllImages
                    ? folderImages.map((image, index) => (
                      <ImagePreview key={image.id}>
                        <ImageWithSkeleton
                          onClick={() => {
                            if (isImageSelected) {
                              handleSelectedImage(image.id, image.image)
                            }
                          }}
                          imgURL={`${IMAGE_CDN}/${image.image}`}
                          isImagesSelected={isImageSelected}
                          thumbnailURL={`${IMAGE_CDN}/${image.thumbnail}`}
                          onViewFullScreen={() =>
                            openLightbox(newFolderImages.length + index)
                          }
                          activateWatermark={isWatermarkActive}
                          watermarkUrl={watermarkUrl}
                        />
                        <ImageName>{getImageNameFromPath(image.image)}</ImageName>
                        {isImageSelected && (
                          <SelectedIconContainer>
                            {selectedFolderImages.includes(image.id) && (
                              <SelectedIcon src={SelectedIconPNG} />
                            )}
                          </SelectedIconContainer>
                        )}
                      </ImagePreview>
                    ))
                    : likedImages.length > 0 &&
                    likedImages.map((image, index) => (
                      <ImagePreview key={image.id}>
                        <ImageWithSkeleton
                          onClick={() => {
                            if (isImageSelected) {
                              handleSelectedImage(image.id, image.image)
                            }
                          }}
                          imgURL={`${IMAGE_CDN}/${image.image}`}
                          isImagesSelected={isImageSelected}
                          thumbnailURL={`${IMAGE_CDN}/${image.thumbnail}`}
                          onViewFullScreen={() =>
                            openLightbox(newFolderImages.length + index)
                          }
                          activateWatermark={isWatermarkActive}
                          watermarkUrl={watermarkUrl}
                        />
                        <LikedImageContainer>
                          <img src={RedLikeIcon} alt="" style={{ height: 16, width: 16 }} />
                        </LikedImageContainer>
                        <ImageName>
                          {(image as LikedImageType).original_file_name ||
                            getImageNameFromPath(image.image)}
                        </ImageName>
                        {isImageSelected && (
                          <SelectedIconContainer>
                            {selectedFolderImages.includes(image.id) && (
                              <SelectedIcon src={SelectedIconPNG} />
                            )}
                          </SelectedIconContainer>
                        )}
                      </ImagePreview>
                    )))}

                {folderLoading && (
                  <LoadingWrap style={{ gridColumn: '1 / -1' }}>
                    <LoadingDots />
                  </LoadingWrap>
                )}
                {currentFolder &&
                  folderImages &&
                  folderImages.length < currentFolder.total_images &&
                  !loadErrorRef.current && (
                    <LoadMoreSentinel ref={loadMoreRef} aria-hidden />
                  )}
              </ImageGrid>
            </>
          )}
        </FormCard>

        {isUpdate && !isImageSelected && (
          <FolderSubmitBar>
            <SubmitHint>
              {newFolderImages.length > 0
                ? `${newFolderImages.length} new image${newFolderImages.length === 1 ? '' : 's'} ready to upload.`
                : 'Folder name has unsaved changes.'}
            </SubmitHint>
            <SubmitButton
              type="button"
              $ready={canSave}
              disabled={!canSave}
              onClick={handleUpdateFolder}
            >
              Save changes
            </SubmitButton>
          </FolderSubmitBar>
        )}

      </ScrollBody>

      {currentFolder?.id && uploadImageModal && (
        <Modal
          onCancel={() => setUploadImageModal(false)}
          open={uploadImageModal}
          footer={null}
          title="Upload Images"
          zIndex={10001}
        >
          <UploadImageModalComponent
            handleImageUpload={handleImageUpload}
            closeModal={() => setUploadImageModal(false)}
            folder_id={currentFolder?.id.toString()}
          />
        </Modal>
      )}
    </PageContainer>
  )
}

export default UpdateFolderPage